import * as Sentry from '@sentry/browser';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import ErrorPopup from '/@/components/error-popup';
import { _ } from '/@/locale';

export default function RouteError() {
    const error = useRouteError();
    const navigate = useNavigate();

    // Log error to Sentry
    if ((window as any).SENTRY_PUBLIC_DSN) {
        Sentry.withScope((scope) => {
            if (isRouteErrorResponse(error)) {
                scope.setExtra('status', error.status);
                scope.setExtra('statusText', error.statusText);
                if (error.data) {
                    scope.setExtra('data', error.data);
                }
            }
            Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
        });
    }

    const handleGoBack = () => {
        navigate(-1);
    };

    let title = _('Ha ocurrido un error...');
    let description = _('Por favor intentá nuevamente.');
    let showNotFound = false;

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            title = _('Página no encontrada');
            description = _('La página que estás buscando no existe.');
            showNotFound = true;
        } else if (error.status === 403) {
            title = _('Acceso denegado');
            description = _('No tienes permiso para acceder a esta página.');
        } else if (error.status === 500) {
            title = _('Error del servidor');
            description = _('Ocurrió un error en el servidor. Por favor intentá más tarde.');
        } else {
            title = _('Ocurrió un error inesperado');
            description = _('Actualizá la página o intentá de nuevo.');
        }
    } else if (error instanceof Error) {
        title = _('Ocurrió un error inesperado');
        description = _('Actualizá la página o intentá de nuevo.');
    }

    const errorDetails =
        process.env.NODE_ENV === 'development' && error ? (
            <pre style={{ margin: 0, fontSize: '12px', whiteSpace: 'pre-wrap' }}>
                {isRouteErrorResponse(error)
                    ? `Status: ${error.status}\nStatusText: ${error.statusText}\nData: ${JSON.stringify(error.data, null, 2)}`
                    : error instanceof Error
                      ? `${error.toString()}\n${error.stack}`
                      : String(error)}
            </pre>
        ) : undefined;

    return (
        <ErrorPopup
            fullPage
            title={title}
            description={description}
            drawingType={showNotFound ? 'not-found' : 'error'}
            showGoBackButton
            onGoBack={handleGoBack}
            errorDetails={errorDetails}
        />
    );
}
